// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Sun, Moon } from 'lucide-react'
import { useTheme } from '@/context/theme-context'
import { Branding } from '@qh/design-tokens/branding'

interface OnboardingLayoutProps {
  children: ReactNode
}

export function OnboardingLayout({ children }: OnboardingLayoutProps) {
  const { theme, toggleTheme } = useTheme()
  const { t } = useTranslation()
  return (
    <div className="min-h-svh bg-background flex flex-col">
      {children}
      <Branding className="px-16 pb-4 pt-2" />
      <button
        onClick={toggleTheme}
        className="fixed bottom-6 right-5 z-50 h-10 w-10 rounded-full bg-card border border-border shadow-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:scale-105 transition-all duration-200"
        aria-label={t('common.toggleTheme')}
      >
        {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>
    </div>
  )
}
